import type { Progress } from '@/api';
import type { TextKey } from '@/str';

export type BadgeKey = 'b1' | 'b10' | 'b25' | 'b35' | 'e1' | 'e20' | 't1' | 'c50';

export const BADGE_NAME: Record<BadgeKey, TextKey> = {
  b1: 'badgeB1',
  b10: 'badgeB10',
  b25: 'badgeB25',
  b35: 'badgeB35',
  e1: 'badgeE1',
  e20: 'badgeE20',
  t1: 'badgeT1',
  c50: 'badgeC50',
};

export interface Badge {
  key: BadgeKey;
  have: number;
  need: number;
  earned: boolean;
}

export function computeBadges(p: Progress): Badge[] {
  const c = p.counters;
  const spec: [BadgeKey, number, number][] = [
    ['b1', c.bilets_passed, 1],
    ['b10', c.bilets_passed, 10],
    ['b25', c.bilets_passed, 25],
    ['b35', c.bilets_passed, Math.max(1, c.bilets_total)],
    ['e1', c.exams_submitted, 1],
    ['e20', c.perfect_exams, 1],
    ['t1', c.topics_mastered, 1],
    ['c50', p.distinct_questions, Math.max(1, Math.ceil(c.bank_total / 2))],
  ];
  return spec.map(([key, have, need]) => ({ key, have, need, earned: have >= need }));
}
